import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useBrandLogoUrl } from "@/branding/BrandingProvider";
import { Mail, MapPin, ShieldX } from "lucide-react";
import { Link } from "@tanstack/react-router";

export const Route = createFileRoute("/declined")({
  component: DeclinedPage,
});

function DeclinedPage() {
  const { t } = useTranslation("portalAccess");
  const { t: tc } = useTranslation("common");
  const navigate = useNavigate();
  const primaryLogoUrl = useBrandLogoUrl("primary");

  const imprintLabel = tc("footer.imprint");
  const privacyPolicyLabel = tc("footer.privacyPolicy");

  return (
    <div className="min-h-screen client-gradient-bg flex flex-col">
      <header className="p-4 sm:p-6">
        <img
          src={primaryLogoUrl}
          alt="JourFx"
          className="h-8 sm:h-10 lg:h-12 w-auto"
        />
      </header>

      <main className="flex-1 flex items-center justify-center p-4 sm:p-6">
        <div className="w-full max-w-md">
          <div className="client-card p-6 sm:p-8 text-center space-y-6">
            <div className="mx-auto w-14 h-14 rounded-2xl bg-red-50 flex items-center justify-center">
              <ShieldX className="w-7 h-7 text-red-500" />
            </div>

            <div className="space-y-3">
              <h1 className="text-2xl font-bold text-[var(--stone-800)]">
                {t("declined.title")}
              </h1>
              <p className="text-[var(--stone-600)] leading-relaxed">
                {t("declined.message")}
              </p>
            </div>

            <div className="pt-2 space-y-3">
              <div className="rounded-xl border border-[var(--stone-200)] bg-[var(--sage-50)] p-4 text-left">
                <p className="text-sm font-semibold text-[var(--stone-800)]">
                  {t("declined.contactTitle")}
                </p>
                <div className="mt-3 space-y-3 text-sm text-[var(--stone-700)]">
                  <a
                    href="mailto:info@md-bb.org"
                    className="flex items-start gap-3 rounded-lg p-2 -mx-2 text-[var(--sage-700)] hover:bg-white/70 transition-colors"
                  >
                    <Mail className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
                    <span>
                      <span className="block font-medium">{t("declined.emailLabel")}</span>
                      <span className="break-all">info@md-bb.org</span>
                    </span>
                  </a>
                  <div className="flex items-start gap-3">
                    <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[var(--stone-500)]" aria-hidden="true" />
                    <span>
                      <span className="block font-medium">{t("declined.addressLabel")}</span>
                      <span>Medizinischer Dienst Berlin-Brandenburg</span>
                      <span className="block">Schlaatzweg 1</span>
                      <span className="block">14473 Potsdam</span>
                    </span>
                  </div>
                </div>
              </div>
              <button
                onClick={() => navigate({ to: "/" })}
                className="w-full px-6 py-3 rounded-xl font-medium text-sm text-[var(--stone-600)] hover:bg-[var(--stone-100)] transition-colors"
              >
                {t("declined.back")}
              </button>
            </div>
          </div>
        </div>
      </main>

      <footer className="client-footer relative z-10">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
          <Link to="/datenschutz" className="client-footer-link">
            {privacyPolicyLabel}
          </Link>
          <span className="text-[var(--stone-300)]" aria-hidden="true">|</span>
          <Link to="/impressum" className="client-footer-link">
            {imprintLabel}
          </Link>
        </div>
      </footer>
    </div>
  );
}
